/**
 * @module core/schemas
 */

// Definitions
import { ISchemaPage } from '../defs';

/**
 * See [[ISchemaPage]]
 */
export const schemaPage: ISchemaPage = {
  container: undefined,
  html: undefined,
  namespace: undefined,
  url: {
    hash: undefined,
    href: undefined,
    path: undefined,
    port: undefined,
    query: {},
  },
};
